import React from 'react';
import { motion } from 'framer-motion';
export function RealProblemSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-cream-dark" data-id="element-164">
      <div className="max-w-3xl mx-auto" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-10 text-center" data-id="element-167">
            The Real Problem
          </h2>

          <p data-id="element-168">
            Here is what nobody tells you when you walk out of that
            neurologist's office with a diagnosis, a pamphlet and an appointment
            three months away:
          </p>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-cream my-10" data-id="element-169">
            <p className="font-serif text-2xl text-charcoal text-center" data-id="element-170">
              The diagnosis explains what your child's brain is doing.
              <br data-id="element-171" />
              <span className="text-amber mt-4 block" data-id="element-172">
                It tells you almost nothing about what to do tonight.
              </span>
            </p>
          </div>

          <p data-id="element-173">
            And so you improvise. You survive. You get through Tuesday and then
            Wednesday hits and you improvise again.
          </p>
          <p data-id="element-174">The problem is not your effort.</p>
          <p data-id="element-175">
            The problem is that your child's nervous system operates on a
            completely different set of rules than the parenting strategies you
            were handed — and almost none of those strategies were designed with
            his brain in mind.
          </p>

          <div className="space-y-6 my-12 pl-6 border-l-2 border-sage" data-id="element-176">
            <p data-id="element-177">
              When your son covers his ears at the grocery store,{' '}
              <span className="font-semibold text-charcoal" data-id="element-178">
                that is not a tantrum.
              </span>
            </p>
            <p data-id="element-179">
              When he refuses to transition from the iPad to dinner,{' '}
              <span className="font-semibold text-charcoal" data-id="element-180">
                that is not defiance.
              </span>
            </p>
            <p data-id="element-181">
              When he melts down because the sock seam is touching his toe
              wrong,{' '}
              <span className="font-semibold text-charcoal" data-id="element-182">
                that is not manipulation.
              </span>
            </p>
          </div>

          <p className="text-2xl font-serif text-charcoal text-center py-6" data-id="element-183">
            That is a sensory nervous system hitting its absolute limit.
          </p>

          <p data-id="element-184">
            And when a nervous system hits its limit, logic doesn't work.
            Rewards don't work. Consequences don't work.
          </p>
          <p data-id="element-185">
            What works is a completely different approach. One built around how
            his brain actually functions.
          </p>
          <p className="font-semibold text-charcoal" data-id="element-186">
            That approach exists. And it is simpler than anything you've tried
            before.
          </p>
        </motion.div>
      </div>
    </section>;
}